import React, { Component } from 'react';

import './css/GapQuestion.css';
import StringUtils from "../../utils/StringUtils";

class GapQuestion extends Component {
    componentWillMount() {
        let gapCount = 0;
        for (const subtask of this.props.subtasks) {
            gapCount += (subtask.match(/{%s}/g) || []).length;
        }
        const answers = this.props.correctAnswer || [];
        this.setState({ answers: answers });
    }

    setScore = (event) => {
        let score = Number.parseInt(event.target.value);
        if (score < 0) score = 0;
        if (score > this.props.subtasks.length) score = this.props.subtasks.length;
        this.props.setScore(this.props.id, score);
    };

    render() {
        let gapIndex = 0;
        let correctSubtasksCount = 0;

        const subtasks = this.props.subtasks.map((subtask, taskIndex) => {
            let taskCorrect = true;

            const content = subtask
                .split(" ")
                .map((item, index, array) => {
                    const key = "gap-" + taskIndex + "-" + index;
                    if (item === "{%s}") {
                        let correct = false;
                        const gap = gapIndex;
                        gapIndex += 1;
                        const userAnswerElement = this.props.userAnswer[gap];
                        const safeAnswer = StringUtils.toSafeString(userAnswerElement);
                        const correctAnswers = this.state.answers[gap] || [];
                        for (const answer of correctAnswers) {
                            if (safeAnswer === StringUtils.toSafeString(answer)) correct = true;
                        }
                        taskCorrect = taskCorrect && correct;
                        return (
                            <span key={key}>
                            <input
                                type="text"
                                className={(correct ? 'correct-word' : 'wrong-word') + " gap"}
                                value={userAnswerElement}
                                readOnly={true}/>
                            </span>);
                    }
                    return (<span key={key}>{StringUtils.parse(item)} </span>);
                });

            if (taskCorrect) correctSubtasksCount += 1;

            return (
                <div key={"subtask-" + taskIndex} className="subtask">
                    {content}
                </div>
            );
        });

        return (
            <div className="task-block gap-question-edit">
                <div className="question-number">Pytanie {this.props.number} (<input type="number" className="score-picker" value={this.props.score} min={0} max={this.props.points} onChange={this.setScore} /> / {subtasks.length})</div>
                <div className="question">{StringUtils.parse(this.props.question)}</div>
                <div className="subtasks">
                    {subtasks}
                </div>
            </div>
        );
    }
}

export default GapQuestion;